<template>
  <v-card class="review-card mb-4" elevation="3">
    <!-- Avatar Section Outside the Card -->
    <div class="d-flex justify-center mb-2" style="position: relative">
      <div
        style="
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0);
          z-index: 1;
        "
      ></div>
    </div>

    <!-- Review Content Section -->
    <v-card-title class="d-flex justify-space-between align-center">
      <!-- Star Rating -->
      <v-rating
        v-model="localRating"
        dense
        readonly
        style="margin-left: auto; margin-right: auto"
        color="amber"
      />
    </v-card-title>

    <!-- Name and Date Section -->
    <v-card-subtitle class="d-flex justify-space-between">
      <span class="reviewer-name">{{ review.name }}</span>
      <span class="review-date">{{ formatDate(review.date) }}</span>
    </v-card-subtitle>

    <!-- Review Text Section -->
    <v-card-text dir="rtl" class="review-text">{{ review.text }}</v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "FakeReview",
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localRating: this.review.rating, // Create a local copy of the rating prop
    };
  },
  methods: {
    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");
.review-card {
  border-radius: 10px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 10px;
  position: relative;
  text-align: center; /* Center the content */
}

.reviewer-name {
  font-family: "Noto Kufi Arabic", sans-serif;
  font-weight: bold;
  font-size: 1em;
}

.review-date {
  font-size: 0.9em;
  color: gray;
}

.review-text {
  font-family: "Noto Kufi Arabic", sans-serif;
  margin-top: 5px;
  line-height: 1.4;
  font-size: 1em;
}

.v-avatar img {
  border-radius: 50%;
}
</style>
